import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=49c78b50"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports